import { useState, useEffect } from 'react';
import { personalInfoRequest } from '../requests/personalInfoRequest';

export const useDataFromOffice = () => {
  const [descriptionThirdCase, setDescriptionThirdCase] = useState('');

  useEffect(() => {
    const getPersonalInfo = async () => {
      const data = await personalInfoRequest();
      setDescriptionThirdCase(data.descriptionThirdCase);
    };
    getPersonalInfo();
  }, []);

  return { descriptionThirdCase };
};
